<template>
    <div style="width: 100%;" class="cards qb-container qb-margin-bottom" :class="setSize">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'card-group',
    props: {
        size: {
            type: String,
            default: '2'
        }
    },
    computed: {
        setSize(){
        if(this.size == '7'){
            return 'grid-7';
        }
        else if(this.size == '6'){
            return 'grid-6';
        }
        else if(this.size == '5'){
            return 'grid-5';
        }
        return 'grid-3';
    }
}
}

</script>

<style scoped>

</style>
